import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

export interface NavItem {
  label: string;
  to: string;
  icon: React.ElementType;
}

export function NavSection({ label, items }: { label: string; items: NavItem[] }) {
  return (
    <div className="mb-4">
      <p className="mb-1 px-3 text-[11px] font-medium uppercase tracking-wide text-text-muted">
        {label}
      </p>
      <nav className="flex flex-col gap-0.5">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.label === "Dashboard"}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-2.5 rounded-lg px-3 py-2 text-[13px] font-medium transition-colors",
                isActive
                  ? "bg-accent/10 text-accent"
                  : "text-text-secondary hover:bg-surface-hover",
              )
            }
          >
            <item.icon size={16} />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
